var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.logLine.subject.project)?_c('div',[_c('i',[_vm._v("\n      "+_vm._s(_vm.logLine.subject.project.name)+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.logLine.subject.user)?_c('div',[_c('i',{staticClass:"text-muted"},[_vm._v("\n      Responsible: "+_vm._s(_vm.logLine.subject.user.full_name)+"\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }